$(document).ready(function () {
  var $toggleBtn = $('.mobile-filter-toggle');
  var $filterForm = $('.faceted-filter-form');
  var $closeBtn = $('.mobile-filter-close');

  if (!$toggleBtn.length || !$filterForm.length) return;

  // Overlay
  var $overlay = $('<div class="filter-overlay"></div>');
  $('body').append($overlay);

  function openDrawer() {
    $filterForm.addClass('is-open');
    $overlay.addClass('is-active');
    $('body').css('overflow', 'hidden');
  }

  function closeDrawer() {
    $filterForm.removeClass('is-open');
    $overlay.removeClass('is-active');
    $('body').css('overflow', '');
  }

  $toggleBtn.on('click', function () {
    openDrawer();
  });

  $overlay.on('click', function () {
    closeDrawer();
  });

  $closeBtn.on('click', function () {
    closeDrawer();
  });
   const $drawer = $('#theme-ajax-cart');

  if (!$drawer.length) return;

  const observer = new MutationObserver(function() {
    if ($drawer.hasClass('is-visible')) {
      $('body').css('overflow', 'hidden'); // stop scroll
    } else {
      $('body').css('overflow', ''); // restore scroll
    }
  });

  observer.observe($drawer[0], {
    attributes: true,
    attributeFilter: ['class']
  });
});

